import { useContext } from 'react';

import { CommentContext } from '../context/content-type-comment-context';
import { ContentTypesCommentService } from '../services/content-types-comment-service';

export const useCommentService = () => {
	const context = useContext(CommentContext);
	if (!context) {
		return {
			commentService: new ContentTypesCommentService(),
		};
	}
	return context;
};
